import { useCallback, useState } from 'react';
import { captureMessage } from '@sentry/react';
import { useApolloClient } from '@apollo/client';
import { clearApolloCachePersist } from '@/utils/apolloInMemoryCache.ts';

export default function useClearCache() {
  const [isClearingCache, setIsClearingCache] = useState<boolean>(false);
  const client = useApolloClient();

  const handleClearCache = useCallback(
    async (shouldResetStore = false) => {
      setIsClearingCache(true);
      try {
        await Promise.allSettled([
          clearApolloCachePersist(),
          client.clearStore(),
        ]);
        if (shouldResetStore) {
          await client.resetStore();
        }
      } catch (error: any) {
        captureMessage(error);
      } finally {
        setIsClearingCache(false);
      }
    },
    [client],
  );

  return [handleClearCache, { isClearingCache }] as const;
}
